import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/organisms/Footer/FooterComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/organisms/Header/index.tsx");
